import { render, staticRenderFns } from "./TestResultContent.vue?vue&type=template&id=ef3fdc46"
import script from "./TestResultContent.vue?vue&type=script&lang=js"
export * from "./TestResultContent.vue?vue&type=script&lang=js"
import style0 from "./TestResultContent.vue?vue&type=style&index=0&id=ef3fdc46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports